const digest = 'bdbe38865628ff6ddc61d0580def1d02a8180a50d01b398c76a6e0f47847870c';
const css = `._badge_lph6u_1{background-color:#006fcf;border-end-end-radius:.25rem;font-size:.5rem;line-height:1.125rem;padding:0 .375rem;position:absolute}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'badge': '_badge_lph6u_1' };
export const badge = '_badge_lph6u_1';
export { css, digest };